module.exports = __webpack_public_path__ + "static/media/a.0e6e4e2c.jpg";